import createIcon from '../../createIcon';

/**
 * @component @name LocationOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNi41QzE0LjM4IDYuNSAxNS41IDcuNjIgMTUuNSA5QzE1LjUgOS43NCAxNS4xNyAxMC4zOSAxNC42NyAxMC44NUwxOC4zIDE0LjQ4QzE5LjI4IDEyLjYyIDIwIDEwLjY4IDIwIDlDMjAgNS4xMyAxNi44NyAyIDEzIDJDMTEuMDIgMiA5LjI0IDIuODMgNy45NiA0LjE1TDExLjE1IDcuMzRDMTEuNjEgNi44MiAxMi4yNiA2LjUgMTMgNi41Wk00LjI3IDNMMyA0LjI3TDYuMTggNy40NUM2LjA3IDcuOTUgNiA4LjQ3IDYgOUM2IDE0LjI1IDEzIDIyIDEzIDIyQzEzIDIyIDE0LjY3IDIwLjE1IDE2LjM4IDE3LjY1TDE5LjczIDIxTDIxIDE5LjczTDQuMjcgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocationOff = createIcon('LocationOff', [
  [
    'path',
    {
      d: 'M13 6.5C14.38 6.5 15.5 7.62 15.5 9C15.5 9.74 15.17 10.39 14.67 10.85L18.3 14.48C19.28 12.62 20 10.68 20 9C20 5.13 16.87 2 13 2C11.02 2 9.24 2.83 7.96 4.15L11.15 7.34C11.61 6.82 12.26 6.5 13 6.5ZM4.27 3L3 4.27L6.18 7.45C6.07 7.95 6 8.47 6 9C6 14.25 13 22 13 22C13 22 14.67 20.15 16.38 17.65L19.73 21L21 19.73L4.27 3Z',
      key: '1lhm2k',
    },
  ],
]);

export default LocationOff;
